<template>
  <div class="flex justify-center min-h-screen text-center p-6 sm:p-0">
    <div
      class="fixed inset-0 bg-gray-500 bg-opacity-75"
      aria-hidden="true">
    </div>
    <div class="fixed w-full h-full justify-center block top-0 left-0 z-50">
      <Main>
        <LoginPrompt
          @closePrompt="closePrompt"
        />
      </Main>
    </div>
  </div>
</template>

<script>
import Main from '../Main.vue'
import LoginPrompt from './LoginPrompt.vue'

export default {
  components: {
    Main,
    LoginPrompt,
  },
  methods: {
    closePrompt() {
      this.$emit('closePrompt')
    },
  },
}
</script>
